import { AlertSamsaraVehicleFeature } from '../features/alert-samsara-vehicle/alert-samsara-vehicle.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class AlertsSamsaraVehicleLayerRenderer extends StandardLayerRenderer {
  protected Feature = AlertSamsaraVehicleFeature;
}
